/**
 * Encode a multi-segment image filename for use in API URLs.
 *
 * Handles two edge cases:
 *  1. Filenames with `/` path separators (e.g. "section-5/image.png")
 *     — each segment is encoded independently so `/` is preserved as a path delimiter.
 *  2. Pre-encoded Unicode characters (e.g. Norwegian ø → %C3%B8)
 *     — react-markdown may pre-encode src attributes; we decode first to avoid
 *       double-encoding (%C3%B8 → %25C3%25B8).
 *
 * Safe to call on already-decoded strings — decodeURIComponent is a no-op
 * when there are no percent-encoded sequences.
 */
export function encodeImageFilename(filename: string): string {
    const decoded = decodeURIComponent(filename);
    return decoded.split('/').map(encodeURIComponent).join('/');
}
